'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colors = require('HubStyleTokens/colors');

var Colors = _interopRequireWildcard(_colors);

var _ComponentWithUniqueIds = require('../mixins/ComponentWithUniqueIds');

var _ComponentWithUniqueIds2 = _interopRequireDefault(_ComponentWithUniqueIds);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactUtils = require('react-utils');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../core/Functions');

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIconCircle = require('../icon/UIIconCircle');

var _UIIconCircle2 = _interopRequireDefault(_UIIconCircle);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIFileInput = _react2.default.createClass({
  displayName: 'UIFileInput',

  mixins: [_ComponentWithUniqueIds2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: {
    accept: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
    buttonClassName: _react.PropTypes.string,
    changeLabel: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
    className: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    selectLabel: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
    showFilePreview: _react.PropTypes.bool.isRequired,
    use: _UIButton2.default.propTypes.use,
    value: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(window.File), _react.PropTypes.shape({
      name: _react.PropTypes.string
    })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      accept: [],
      changeLabel: function changeLabel() {
        return _I18n2.default.text('salesUI.UIFileInput.defaultChangeLabel');
      },
      selectLabel: function selectLabel() {
        return _I18n2.default.text('salesUI.UIFileInput.defaultSelectLabel');
      },
      showFilePreview: true,
      use: 'secondary'
    };
  },
  handleClick: function handleClick() {
    (0, _reactDom.findDOMNode)(this.refs.file).click();
  },
  handleFileSelect: function handleFileSelect(evt) {
    var onChange = this.props.onChange;

    (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent2.default)(evt.target.files[0], evt));
  },
  getButtonText: function getButtonText(_ref) {
    var changeLabel = _ref.changeLabel,
        selectLabel = _ref.selectLabel,
        value = _ref.value;

    if (value) {
      return (0, _lazyEval2.default)(changeLabel);
    }
    return (0, _lazyEval2.default)(selectLabel);
  },
  renderStatusIcon: function renderStatusIcon(_ref2) {
    var value = _ref2.value;

    if (!value) {
      return null;
    }
    return _react2.default.createElement(_UIIconCircle2.default, {
      backgroundColor: Colors.OZ_MEDIUM,
      className: 'private-file-input__success-icon',
      color: Colors.OLAF,
      name: _icons2.default.SUCCESS,
      padding: 0.25,
      size: 9
    });
  },
  renderFilePreview: function renderFilePreview(_ref3, _ref4) {
    var showFilePreview = _ref3.showFilePreview,
        value = _ref3.value;
    var renderedStatusIcon = _ref4.renderedStatusIcon;

    if (!showFilePreview) {
      return null;
    }
    return _react2.default.createElement(
      'label',
      { className: 'm-left-3', htmlFor: this.getUniqueId('file') },
      renderedStatusIcon,
      ' ',
      value ? value.name : null
    );
  },
  render: function render() {
    var _props = this.props,
        accept = _props.accept,
        buttonClassName = _props.buttonClassName,
        changeLabel = _props.changeLabel,
        className = _props.className,
        __onChange = _props.onChange,
        selectLabel = _props.selectLabel,
        showFilePreview = _props.showFilePreview,
        use = _props.use,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['accept', 'buttonClassName', 'changeLabel', 'className', 'onChange', 'selectLabel', 'showFilePreview', 'use', 'value']);

    var renderedStatusIcon = this.renderStatusIcon({ value: value });

    // The UIButton HAS to be rendered BEFORE the input or change events won't
    // fire in safari.
    // Why you ask? I'm guessing something to do with when/how React updates
    // the DOM but really I have no idea.
    return _react2.default.createElement(
      'span',
      { className: (0, _reactUtils.classNames)('private-file-button', className) },
      _react2.default.createElement(
        _UIButton2.default,
        {
          className: buttonClassName,
          onClick: this.handleClick,
          use: use
        },
        this.getButtonText({ changeLabel: changeLabel, selectLabel: selectLabel, value: value })
      ),
      this.renderFilePreview({ showFilePreview: showFilePreview, value: value }, { renderedStatusIcon: renderedStatusIcon }),
      _react2.default.createElement('input', _extends({}, rest, {
        accept: accept.join(','),
        className: 'hidden',
        id: this.getUniqueId('file'),
        onChange: this.handleFileSelect,
        ref: 'file',
        type: 'file'
      }))
    );
  }
});

exports.default = (0, _Controllable2.default)(UIFileInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/input/UIFileInput.js
// module id = 330
// module chunks = 0